import { render, staticRenderFns } from "./WizardStepBehavior.vue?vue&type=template&id=324b1c8e&scoped=true"
import script from "./WizardStepBehavior.vue?vue&type=script&lang=js"
export * from "./WizardStepBehavior.vue?vue&type=script&lang=js"
import style0 from "./WizardStepBehavior.vue?vue&type=style&index=0&id=324b1c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b1c8e",
  null
  
)

export default component.exports